module.exports = __webpack_public_path__ + "/login_ui/img/mx-4a1f4d91f3fbfb2bf9fa20b9cacaa105.svg";